import { createElement } from "react";
import React from "react";
import { reactApi } from "./fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "./Context.js";
import { API_Document_Document, generateQueryString, API_Document_Download } from "./Shared/Urls.js";
import { parse } from "./fable_modules/fable-library-js.4.24.0/Guid.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.8.0/Internal.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { Document$_$reflection } from "./Shared/ApiDataTypes.js";
import { testRedirect, extraCoders } from "./Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { cons, ofArray, empty } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { some, unwrap, map, defaultArg } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { obj_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { fromString } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { createObj, uncurry2 } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { append, empty as empty_1, singleton, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Typography, Skeleton } from "@mui/material";
import { Documents_MetaCard_6F67B1E7 } from "./Components/Documents/DocumentViewer.js";
import { Audits_Table_Z721C83C5 } from "./Components/Documents/Audits.js";

export function Documents_View_Z721C83C5(documents_View_Z721C83C5InputProps) {
    let elems_4, elems, elems_3;
    const documentId = documents_View_Z721C83C5InputProps.documentId;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setLoading = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const document$ = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const mounted = patternInput_2[0];
    const containerRef = reactApi.useRef(undefined);
    const url = API_Document_Download(parse(documentId)) + generateQueryString([["preview", ""]]);
    let patternInput_3;
    const matchValue = ctx.Session;
    if (matchValue != null) {
        const s = matchValue;
        patternInput_3 = [s.IsPtg, s.IsAdmin ? true : s.IsSuperAdmin];
    }
    else {
        patternInput_3 = [false, false];
    }
    reactApi.useEffect(() => {
        if (!mounted) {
            const matchValue_1 = containerRef.current;
            if (matchValue_1 != null) {
                const _elem = matchValue_1;
                patternInput_2[1](true);
            }
        }
    });
    useEffectOnce(() => {
        let properties_2;
        const url_1 = API_Document_Document(parse(documentId));
        setLoading(true);
        let pr_2;
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(Document$_$reflection(), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = extraCoders;
        try {
            const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url_1, properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(Document$_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                    let matchValue_2;
                    return Promise.resolve((matchValue_2 = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue_2.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_2.fields[0]])])) : (new FSharpResult$2(0, [matchValue_2.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
        pr_2.then((res) => {
            if (res.tag === 0) {
                patternInput_1[1](res.fields[0]);
            }
            else {
                console.error(some("Could not download document metadata:"), res.fields[0]);
            }
            setLoading(false);
        });
    });
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        columnGap: 30 + "px",
        width: 100 + "%",
        height: 100 + "%",
    }], (elems_4 = [createElement("div", createObj(ofArray([["id", "document-preview-container"], ["ref", containerRef], ["style", {
        flexGrow: 2,
        minWidth: 21 + "cm",
        height: 100 + "%",
    }], (elems = toList(delay(() => (patternInput[0] ? singleton(MuiHelpers_createElement(Skeleton, [["width", 210 + "mm"], ["height", 297 + "mm"]])) : (mounted ? singleton(createElement("embed", {
        style: {
            width: 100 + "%",
            height: 100 + "%",
        },
        src: url,
        onLoad: (ev) => {
            console.debug("Load document", ev);
        },
    })) : empty_1())))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["id", "document-metadata-container"], ["style", {
        display: "flex",
        flexDirection: "column",
        rowGap: 40 + "px",
        flexShrink: 1,
        flexBasis: 800 + "px",
    }], (elems_3 = toList(delay(() => {
        let elems_1;
        if (document$ != null) {
            const doc_1 = document$;
            return append(singleton(createElement("div", createObj(ofArray([["style", {}], (elems_1 = [MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", "Dokumentinformasjon"]]), createElement(Documents_MetaCard_6F67B1E7, doc_1)], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let elems_2;
                return (patternInput_3[1] ? true : patternInput_3[0]) ? singleton(createElement("div", createObj(ofArray([["style", {}], (elems_2 = [MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", "Endringslogg"]]), createElement(Audits_Table_Z721C83C5, {
                    documentId: documentId,
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : empty_1();
            }));
        }
        else {
            return singleton(createElement("p", {
                children: ["Loading..."],
            }));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

